import { SxProps } from "@mui/material";
import { FC, Fragment } from "react";
import { useAppSelector } from "../../store/hooks";
import PPAppBar from "../UI/PPAppBar";
import PPFooter from "../UI/PPFooter";
import PPSection from "../UI/PPSection";
import PPSkeleton from "../UI/PPSkeleton";
import PPViewSection from "../UI/PPViewSection";
import LoadFormConfiguration from "../model/LoadFormConfiguration";
import {
  buildRow,
  componentConfiguration,
  isSectionTypeView,
} from "../model/field-configuration";
import { ExtendedAttributes } from "../model/form-configuration";
import DefaultLayout from "./DefaultLayout";
import StepperLayout from "./StepperLayout";

const PublicFormLayout: FC<{}> = () => {
  const { form } = useAppSelector((state) => state.form);
  const ppsections: JSX.Element[] = form.sections.map((section) =>
    isSectionTypeView(section) ? (
      <PPViewSection key={section.id} show={true} section={section}>
        {componentConfiguration(section).map(buildRow)}
      </PPViewSection>
    ) : (
      <PPSection key={section.id} show={true} section={section}>
        {componentConfiguration(section).map(buildRow)}
      </PPSection>
    )
  );

  let body = <PPSkeleton />;
  if (form.sections && form.sections.length > 0) {
    const formExtAttr: ExtendedAttributes | undefined = form.extendedAttributes;
    let factor: string = "default";
    if (formExtAttr) factor = formExtAttr.factor ?? "default";
    if (factor == "stepper") {
      body = <StepperLayout>{ppsections}</StepperLayout>;
    } else {
      body = <DefaultLayout>{ppsections}</DefaultLayout>;
    }
  }

  return (
    <Fragment>
      <LoadFormConfiguration />
      <PPAppBar />
      {body}
      <PPFooter />
    </Fragment>
  );
};

export default PublicFormLayout;
//PublicFormLayout.whyDidYouRender = true;
